import React, {useState} from 'react';
import {ErrorMessage, Field} from "formik";
import NumberKeyboard from "../../components/NumberKeyboard";
import {IconButton, Stack} from "@mui/material";
import {ChevronLeft, ChevronRight, South} from "@mui/icons-material";
import {formatCurrency} from "../../utils";

function StageAmount({ submitform, values, setFieldValue }) {
  let [focus, setFocus] = useState('amountSrc');

  const amountFormat = (amount, currency) => {
    if (!amount) {
      return 0;
    }
    return formatCurrency(amount, currency);
  };
  const rateFormat = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })

  const onNumberPress = (values, setFieldValue) => (value) => {
    const currency = focus === 'amountSrc' ? 'USD' : 'LBP';
    const amount = values[focus];

    // console.log(`press ${value}`, values);
    let newValue = currency === 'LBP' ? amount.slice(0, -3) : amount;
    if (value === 'del') {
      newValue = newValue.slice(0, -1);
    } else if (amount === '0') {
      newValue = value;
    } else {
      newValue = `${newValue}${value}`;
    }
    if (currency === 'LBP') {
      newValue += '000';
    }
    setFieldValue(focus, newValue || '0');
  };
  const onReturnKey = () => {
    if (parseFloat(values.amountSrc) > 0 && parseFloat(values.amountRes) > 0) {
      submitform()
    } else if (parseFloat(values.amountSrc) > 0) {
      setFocus('amountRes');
    }
  }

  const previousDate = () => {
    const date = new Date(values.date);
    date.setDate(date.getDate() - 1);
    setFieldValue('date', date.toISOString().substr(0, 10));
  }
  const nextDate = () => {
    const date = new Date(values.date);
    date.setDate(date.getDate() + 1);
    setFieldValue('date', date.toISOString().substr(0, 10));
  }

  return <div className="stage-amount">

    <Stack className="date-select" direction="row" spacing={1} justifyContent="center">
      <IconButton aria-label="previous day" onClick={previousDate}>
        <ChevronLeft />
      </IconButton>
      <Field type="date" name="date" />
      <IconButton aria-label="next day" onClick={nextDate}>
        <ChevronRight />
      </IconButton>
    </Stack>

    <div className={`amount amount-source ${focus==='amountSrc' ? 'focused' : ''}`} onClick={() => setFocus('amountSrc')}>
      <Field type="hidden" name="amountSrc" />
      <span className="formatted">
          {!values.amountSrc || values.amountSrc === 0 ? '$' : ''}
        {amountFormat(values.amountSrc, 'USD')}
        </span>
      <span className="error"><ErrorMessage name="amountSrc" /></span>
    </div>

    <div className="exchange-rate">
        <span className="rate">{values.amountSrc > 0 && values.amountRes > 0
          ? rateFormat.format(values.amountRes / values.amountSrc)
          : ''}</span>
      <South fontSize={'large'} />
    </div>

    <div className={`amount amount-result ${focus==='amountRes' ? 'focused' : ''}`} onClick={() => setFocus('amountRes')}>
      <Field type="hidden" name="amountRes" />
      <span className="formatted">
          {!values.amountRes || values.amountRes === 0 ? 'LBP ' : ''}
        {amountFormat(values.amountRes, 'LBP')}
        </span>
      <span className="error"><ErrorMessage name="amountRes" /></span>
    </div>

    <NumberKeyboard onFormSubmit={onReturnKey} onKeyPress={onNumberPress(values, setFieldValue)} />
  </div>;
}

export default StageAmount;